import React, { CSSProperties, use, useEffect, useRef } from 'react';

interface IMapplsMapProp
{
    token: string;
    style?: CSSProperties | undefined;
    hotelLocation?: { lat: number, lng: number}
    userLocation?: { lat: number, lng: number}
    pathCoordinates?: Array<{ lat: number, lng: number}>
}

const MapplsMap = (props: IMapplsMapProp) => {
      const mapRef = useRef<HTMLDivElement>(null);
      const [map, setMap] = React.useState<any>(null);

    useEffect(() => {
    // Define the global callback BEFORE loading the script
    (window as any).initMap1 = () => {
      console.log('Map SDK callback triggered');

      const container = mapRef.current;
      if (!container) {
        console.error('Map container not defined!');
        return;
      }

      // Now Mappls should be available
      if ((window as any).mappls) {
        const map = new (window as any).mappls.Map(container, {
          center: [80.186294, 12.920533],
          zoom: 14
        });

        setMap(map);

       
      } else {
        console.error('mappls is still undefined');
      }
    };

    // Dynamically load the SDK script
    const script = document.createElement('script');
    script.src =
      `https://apis.mappls.com/advancedmaps/api/${props.token}/map_sdk?layer=vector&v=3.0&callback=initMap1`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
      delete (window as any).initMap1;
    };
  }, []);

  useEffect(() => {
    if (map && props.hotelLocation) {
      console.log('Map instance is ready:', map);
      map.setCenter({ lat: props.hotelLocation.lat, lng: props.hotelLocation.lng });

      var hotelmarker = (window as any).mappls.Marker({
        map: map,
        position: { lat: props.hotelLocation.lat, lng: props.hotelLocation.lng }
      });

      if(props.userLocation){
      var userLocationMarker = (window as any).mappls.Marker({
        map: map,
        position: { lat: props.userLocation.lat, lng: props.userLocation.lng }
      });
    }


    }
  }, [map, props.hotelLocation, props.userLocation]);


  useEffect(() => {
    if (map && props.pathCoordinates && props.pathCoordinates.length > 0) {
     var polyline =(window as any).mappls.Polyline({
        map:map,
        path: props.pathCoordinates,
        });

    }
  }, [map, props.pathCoordinates]);



    return (
        <div
            ref={mapRef} id="map"
            style={props.style}
        />
    );
};

export default MapplsMap;
